import { FETCH_SIG_SIGNODE_CONNECTIONID} from "../../actionTypes";
import { fetchSigSigNodeandConectionId } from "../../../../api/dashboard/sigtran/sigtran";

const request = () => ({ type: FETCH_SIG_SIGNODE_CONNECTIONID.REQUEST });
const failure = (error) => ({ type: FETCH_SIG_SIGNODE_CONNECTIONID.FAILURE, error });
const success = (data) => ({ type: FETCH_SIG_SIGNODE_CONNECTIONID.SUCCESS,data});


export const getSigSigNodeandConectionId = (cp_name) => {
  return (dispatch, getState) => {
    dispatch(request());
    return fetchSigSigNodeandConectionId(cp_name)
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve(true);
      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve(false);
      });
  };
};
